var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyWellbeing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MyWellbeing") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.772 50.2279 0.772 50.2279 51 0 51"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MyWellbeing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(19.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2887,19 C18.0247,19 16.2527,20.773 16.2527,23.037 C16.2527,26.261 19.6487,29.342 24.7927,34.008 L25.1197,34.304 L25.4227,34.029 C30.5897,29.333 33.9767,26.256 33.9767,23.037 C33.9767,20.773 32.2027,19 29.9387,19 C28.6507,19 27.3757,19.592 26.5307,20.586 L25.1137,22.248 L23.6967,20.586 C22.8517,19.592 21.5767,19 20.2887,19 L20.2887,19 Z M25.1087,39.325 L22.3077,36.774 C16.4157,31.432 12.5317,27.911 12.5317,23.037 C12.5317,18.688 15.9397,15.279 20.2887,15.279 C22.0117,15.279 23.7177,15.854 25.1137,16.865 C26.5117,15.854 28.2177,15.279 29.9387,15.279 C34.2887,15.279 37.6967,18.688 37.6967,23.037 C37.6967,27.902 33.8247,31.42 27.9647,36.746 L25.1087,39.325 Z",
    id: "Fill-1",
    fill: "#FCBC00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.000000, 0.228100)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1139,4.4926 C13.3179,4.4926 3.7199,14.0906 3.7199,25.8866 C3.7199,37.6816 13.3179,47.2796 25.1139,47.2796 C36.9099,47.2796 46.5079,37.6816 46.5079,25.8866 C46.5079,14.0906 36.9099,4.4926 25.1139,4.4926 M25.1139,51.0006 C11.2649,51.0006 -0.0001,39.7346 -0.0001,25.8866 C-0.0001,12.0366 11.2649,0.7716 25.1139,0.7716 C38.9629,0.7716 50.2279,12.0366 50.2279,25.8866 C50.2279,39.7346 38.9629,51.0006 25.1139,51.0006",
    id: "Fill-3",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWellbeing);
export default __webpack_public_path__ + "static/media/my-wellbeing.fb673a435d50eceac8665f6dcc7584f3.svg";
export { ForwardRef as ReactComponent };